'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../~/shortid/index.js
// module id = 846
// module chunks = 1